import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICompanyActiveStatus, IConfirmationSpaceCompanyExistingAccount } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-dialog-space-company-confirmation',
  templateUrl: './dialog-space-company-confirmation.component.html',
  styleUrl: './dialog-space-company-confirmation.component.scss',
})
export class DialogSpaceCompanyConfirmationComponent {
  constructor(
    public _dialogRef: MatDialogRef<DialogSpaceCompanyConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationSpaceCompanyExistingAccount,
  ) {
    if (this.data.button == '') this.data.button = 'Submit';
  }
}
